<template>
    <transition name="fade">
        <div class="modal-container">
            <ui-card
                class="ui-card"
                @submit="handleSubmit"
                :submitText="$t('actions.save')"
                @cancel="handleCancel"
            >
                <ui-form-field :label="$tc('models.building', 1)" :rules="showBuildingDropdown ? 'required' : ''">
                    <div v-if="showBuildingDropdown">
                        <select v-model="selectedBuildingId" class="form-select mt-1 block w-full border" @change="onBuildingChange">
                            <option v-for="building in userBuildingDetails.buildingAlternatives" :key="building.id" :value="building.id">
                                {{ building.name }}
                            </option>
                        </select>
                        <p class="text-sm text-gray-500 infoText">{{ $t('info.choose_building') }}</p>
                    </div>
                    <div v-else-if="currentBuilding">
                        <p>{{ currentBuilding.name }}</p>
                        <p class="text-sm text-gray-500 infoText">{{ $t('info.placed_in_building') }}</p>
                    </div>
                </ui-form-field>

                <ui-form-field :label="$tc('models.department', 1)" :rules="showDepartmentDropdown ? 'required' : ''" v-if="currentDepartment || showDepartmentDropdown">
                    <div v-if="showDepartmentDropdown">
                        <select v-model="selectedDepartmentId" class="form-select mt-1 block w-full border">
                            <option v-for="department in availableDepartments" :key="department.id" :value="department.id">
                                {{ department.name }}
                            </option>
                        </select>
                         <p class="text-sm text-gray-500 infoText">{{ $t('info.choose_department') }}</p>
                    </div>
                    <div v-else-if="currentDepartment">
                        <p>{{ currentDepartment.name }}</p>
                        <p class="text-sm text-gray-500 infoText">{{ $t('info.placed_in_department') }}</p>
                    </div>
                </ui-form-field>

                <div style="place-self: flex-end;">
                    <ui-button
                        type="green"
                        size="small"
                        uppercase
                        @click="handleSubmit()"
                    >{{ $t('actions.confirm') }}</ui-button>
                </div>                    
            </ui-card>
        </div>
    </transition>
</template>

<script>
import UiCard from '@/components/ui/UiCard';
import UiFormField from '@/components/ui/UiFormField';
import UiButton from '@/components/ui/UiButton';
export default {
    props: {
        userBuildingDetails: {
        type: Object,
        required: true
        },
    },
    components: {
        UiCard,
        UiFormField,
        UiButton,
    },
    data() {
        return {
            selectedBuildingId: null,
            selectedDepartmentId: null
        }
    },
    computed: {
        showBuildingDropdown() {
            return this.userBuildingDetails.buildingAlternatives && this.userBuildingDetails.buildingAlternatives.length > 1;
        },
        showDepartmentDropdown() {
            return this.availableDepartments.length > 1;
        },

        currentDepartment() {
            if (!this.selectedDepartmentId) {
                return null;
            }

            console.log("Selected Department ID:", this.selectedDepartmentId);
            if (this.userBuildingDetails.department && this.userBuildingDetails.department.id === this.selectedDepartmentId) {
                return this.userBuildingDetails.department;
            }

            if (this.userBuildingDetails.departmentAlternatives) {
                return this.userBuildingDetails.departmentAlternatives.find(
                    department => department.id === this.selectedDepartmentId
                );
            }

            return null;
        },
        currentBuilding() {
            if (!this.selectedBuildingId) {
                return null;
            }

            console.log("Selected Building ID:", this.selectedBuildingId);
            if (this.userBuildingDetails.building && this.userBuildingDetails.building.id === this.selectedBuildingId) {
                return this.userBuildingDetails.building;
            }

            if (this.userBuildingDetails.buildingAlternatives) {
                return this.userBuildingDetails.buildingAlternatives.find(
                    building => building.id === this.selectedBuildingId
                );
            }

            return null;
        },
        selectedBuilding() {
            return this.currentBuilding;
        },
        availableDepartments() {
            if (!this.selectedBuildingId || !this.userBuildingDetails || !this.userBuildingDetails.departmentAlternatives) {
                return [];
            }
            const availableDepartments = this.userBuildingDetails.departmentAlternatives.filter(
                department => department.buildingId == this.selectedBuildingId
            );
            return availableDepartments;
        }
    },
    mounted() {
        this.initializeSelections();
    },
    methods: {
        initializeSelections() {
            if (this.userBuildingDetails.building) {
                this.selectedBuildingId = this.userBuildingDetails.building.id;
            } else if (this.userBuildingDetails.buildingAlternatives && this.userBuildingDetails.buildingAlternatives.length > 0) {
                this.selectedBuildingId = this.userBuildingDetails.buildingAlternatives[0].id;
            }

            this.$nextTick(() => {
                console.log("Available Departments after Building Init:", this.availableDepartments);
                if (this.userBuildingDetails.department && this.userBuildingDetails.department.buildingId === this.selectedBuildingId) {
                    this.selectedDepartmentId = this.userBuildingDetails.department.id;
                } else if (this.availableDepartments.length > 0) {
                    this.selectedDepartmentId = this.availableDepartments[0].id;
                }
            });
            
        },
        onBuildingChange(event) {
            const newBuildingId = event.target.value;
            this.selectedBuildingId = newBuildingId;
            
            // Always update department selection when building changes
            this.$nextTick(() => {
                if (this.availableDepartments.length > 0) {
                    this.selectedDepartmentId = this.availableDepartments[0].id;
                } else {
                    this.selectedDepartmentId = null;
                }
            });
        },
        handleSubmit() {
            this.$emit('submit', {
                buildingId: this.selectedBuildingId,
                departmentId: this.selectedDepartmentId
            });
        },
        handleCancel() {
            this.$emit('cancel');
        }
    }
}
</script>
<style lang="scss" scoped>
.modal-container {
  @apply fixed inset-0 flex items-center justify-center px-3 py-6;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;

  @screen sm {
    @apply px-4 py-8;
  }
}
.ui-card {
  min-width: 300px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.infoText {
  max-width: 400px;
  margin-top: 10px; 
}
</style>